import React, { useState } from 'react';
import { CalendarCheck, Loader2 } from 'lucide-react';
import { api } from '../context/AuthContext';

const fmt = (iso) => { try { return new Date(iso).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }); } catch { return iso; } };

export const BewerbungEinladen = ({ it, toast, onDone }) => {
  const [busy, setBusy] = useState(false);
  const liste = it.einladungen || [];
  const letzte = liste[liste.length - 1];
  const senden = async () => {
    const frage = letzte
      ? `${it.name} wurde bereits am ${fmt(letzte.am)} von ${letzte.von} eingeladen.\nEinladung erneut senden?`
      : `${it.name} per E-Mail zum persönlichen Kennenlernen einladen?\nDer Bewerber wird gebeten, zur Terminvereinbarung in der Kanzlei anzurufen.`;
    if (!window.confirm(frage)) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/anfragen/bewerbungen/${it.bewerbung_id}/einladen`);
      toast({ title: 'Einladung gesendet', description: `an ${it.email} – Kopie an die Kanzlei` });
      onDone(data);
    } catch (e) {
      toast({ title: 'Einladung fehlgeschlagen', description: e?.response?.data?.detail || e.message, variant: 'destructive' });
    } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2">
      <button type="button" onClick={senden} disabled={busy || !it.email}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-[11px] tracking-wider rounded-sm bg-[#1B3A5C] text-white hover:bg-[#b8893d] transition-colors duration-200 disabled:opacity-50"
        data-testid={`bewerbung-einladen-${it.bewerbung_id}`}>
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <CalendarCheck className="w-3.5 h-3.5" />}
        {letzte ? 'ERNEUT EINLADEN' : 'ZUM KENNENLERNEN EINLADEN'}
      </button>
      {letzte && <span className="text-xs text-emerald-700" data-testid={`bewerbung-eingeladen-${it.bewerbung_id}`}>Einladung gesendet am {fmt(letzte.am)} von {letzte.von}{liste.length > 1 ? ` (${liste.length}×)` : ''}</span>}
    </div>
  );
};
